var render, staticRenderFns
import script from "./BarChartAll.vue?vue&type=script&lang=js&"
export * from "./BarChartAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a62d78c",
  null
  
)

export default component.exports